import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParty = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M7.73366 15.0664L2.66699 29.3331L16.9337 24.2797",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M5.33301 4H5.34634",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_3",
			d: "M29.333 10.6665H29.3463",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_4",
			d: "M20 2.6665H20.0133",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_5",
			d: "M29.333 26.6665H29.3463",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_6",
			d: "M29.3337 2.6665L26.347 3.6665C25.4968 3.94969 24.7714 4.51936 24.2948 5.27814C23.8181 6.03691 23.6198 6.93769 23.7337 7.8265C23.867 8.97317 22.9737 9.99984 21.8003 9.99984H21.2937C20.147 9.99984 19.1603 10.7998 18.947 11.9198L18.667 13.3332",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_7",
			d: "M29.3337 17.3331L28.2403 16.8931C27.0937 16.4397 25.8137 17.1597 25.6003 18.3731C25.4537 19.3064 24.6403 19.9997 23.6937 19.9997H22.667",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_8",
			d: "M14.6667 2.6665L15.1067 3.75984C15.56 4.9065 14.84 6.1865 13.6267 6.39984C12.6933 6.53317 12 7.35984 12 8.3065V9.33317",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_9",
			d: "M14.6657 17.3332C17.239 19.9065 18.439 22.8932 17.3324 23.9999C16.2257 25.1065 13.239 23.9065 10.6657 21.3332C8.09238 18.7599 6.89238 15.7732 7.99905 14.6665C9.10571 13.5599 12.0924 14.7599 14.6657 17.3332Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgParty;
